import actions from './actions'

export default function MlfbDocumentsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_MLFBDOCUMENT2:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
   
    default:
      return state
  }
}
